module.exports = __webpack_public_path__ + "img/cloud-computing.645b15b0.svg";